import React from 'react'
import { BarLoader } from '../../components/Loader'

export const Loading = React.memo(
    () => {
        return (
            <div className="fixed grid place-content-center z-[1200] top-0 left-0 right-0 w-lvw h-screen bg-whiteGrayish dark:bg-primary-dark">
                <div className="m-auto"><BarLoader /></div>
            </div>
        )
    }
)
